/**
 * CNPJ: limpeza, validação dos dígitos verificadores e formatação.
 * Aceita também o CNPJ alfanumérico (Receita Federal, a partir de julho de 2026): as 12 primeiras
 * posições podem ter letras; os 2 dígitos verificadores continuam numéricos. Cada caractere vale
 * (código ASCII − 48), o que mantém o cálculo antigo para CNPJs só de números.
 */

/** Remove pontuação e deixa letras em maiúsculas. */
export function cleanCnpj(raw: string): string {
  return raw.toUpperCase().replace(/[^0-9A-Z]/g, '');
}

const value = (c: string) => c.charCodeAt(0) - 48;

function checkDigit(base: string): number {
  let weight = 2;
  let sum = 0;
  for (let i = base.length - 1; i >= 0; i--) {
    sum += value(base[i]!) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  const r = sum % 11;
  return r < 2 ? 0 : 11 - r;
}

export function isValidCnpj(raw: string): boolean {
  const c = cleanCnpj(raw);
  if (!/^[0-9A-Z]{12}[0-9]{2}$/.test(c)) return false;
  if (/^(\d)\1{13}$/.test(c)) return false; // 00000000000000, 11111111111111...
  const d1 = checkDigit(c.slice(0, 12));
  const d2 = checkDigit(c.slice(0, 12) + d1);
  return c.endsWith(`${d1}${d2}`);
}

/** 12.345.678/0001-95 */
export function formatCnpj(raw: string): string {
  const c = cleanCnpj(raw);
  if (c.length !== 14) return raw;
  return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12)}`;
}
